<template>
  <section>
    <b-row>
      <b-col md="12">
        <h3 class="font-weight-bold text-left pb-4 px-4">
          {{ $t("product-match-group-main-title", { name: group_match.name }) }}
        </h3>
      </b-col>
    </b-row>
    <transition name="zoom" :duration="2500" @after-enter="showContent = true">
      <b-row v-if="showAnim">
        <b-col md="12">
          <b-card class="bg-light-gray border-0 padding-none">
            <b-card-body class="overflow-auto" style="max-height:150px;">
              <div v-for="(match, index) in group_match.results" :key="index">
                <b-row
                  v-bind:class="{
                    matchResult: match.result.STATUS !== 'FULL FIT'
                  }"
                  class="text-center"
                >
                  <b-col cols="1">
                    <input
                      type="checkbox"
                      v-model="
                        groupAmounts.find(x => x._id == match._id).enabled
                      "
                      @input="updateAmount(match._id)"
                      :disabled="!match.result.SIZE"
                    />
                  </b-col>
                  <b-col>
                    <p class="text-left">
                      {{ match.user.first_name }}
                      {{ match.user.last_name }}
                    </p>
                  </b-col>
                  <b-col cols="2">
                    <input
                      type="number"
                      :min="1"
                      :disabled="
                        !groupAmounts.find(x => x._id == match._id).enabled ||
                          !match.result.SIZE
                      "
                      style="width: 100%"
                      :value="
                        groupAmounts.find(x => x._id == match._id).quantity
                      "
                      :data-id="match._id"
                      @input="updateQuantity"
                    />
                  </b-col>
                  <b-col cols="3">
                    <p class="text-left">
                      <b>{{ match.result.SIZE }}</b>
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
          </b-card>
          <b-card-footer class="pb-5 border-top">
            <b-col md="12">
              <b-button
                block
                variant="black"
                @click="addProduct"
                class="rounded px-1 py-2"
                :disabled="!this.groupSizes.length"
              >
                <Cart class="mr-1" />
                <b>{{ $t("add-to-cart") }}</b>
              </b-button>
              <b-button
                block
                variant="link"
                @click="sendMatchData"
                class="rounded px-1 py-2"
                :disabled="!this.groupSizes.length"
              >
                <b>{{ $t("match-group-mail-results") }}</b>
              </b-button>
              <p v-if="showSentMessage" class="text-center">
                {{ sentMessage }}
              </p>
            </b-col>
          </b-card-footer>
        </b-col>
      </b-row>
    </transition>
    <b-row class="mt-3">
      <b-col md="12" class="text-left">
        <b-button
          v-if="friendsVerification || groupsVerification"
          variant="link"
          @click="
            () => {
              $router.push({ name: 'others' });
              $store.commit('ui/SET_UI_HEADER_BACK_ACTIVE', true);
            }
          "
          class="font-weight-bold"
          ><u>{{ $t("product-match-someone-else") }}</u>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-left">
        <b-button
          variant="link"
          @click="$store.dispatch('application/close')"
          class="font-weight-bold"
        >
          <u> {{ $t("product-match-continue-shopping") }}</u>
        </b-button>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Cart from "../../assets/images/cart.svg";
require("vue2-animate/dist/vue2-animate.min.css");

export default {
  name: "pages-product-match",
  components: {
    Cart
  },
  mounted() {
    this.showAnim = true;
  },
  data() {
    return {
      showAnim: false,
      showContent: false,
      sentMessage: null,
      showSentMessage: false,
      groupSizes: [],
      groupAmounts: []
    };
  },
  watch: {
    group_match: function() {
      for (let i = 0; i < this.group_match.results.length; i++) {
        let groupUser = this.group_match.results[i];
        if (groupUser.result.SIZE) {
          this.groupSizes.push(groupUser.result.SIZE);
          this.groupAmounts.push({
            _id: groupUser._id,
            quantity: this.desiredQuantity ? this.desiredQuantity : 1,
            enabled: true,
            size: groupUser.result.SIZE
          });
        } else {
          this.groupAmounts.push({
            _id: groupUser._id,
            quantity: 0,
            enabled: false
          });
        }
      }
    }
  },
  created() {
    this.$store.commit(
      "ui/SET_POST_LOADING_TEXT",
      this.$t("match-loading-size-found")
    );
    this.$store.commit("ui/SET_POST_LOADING_ANIMATION_SIZE_FOUND");
    this.$store.commit(
      "ui/SET_LOADING_TEXT",
      this.$t("match-loading-checking-passports")
    );
    this.$store.commit("ui/SET_LOADING", true);
    this.$store
      .dispatch("groups/matchGroup")
      .then(() => this.$store.commit("ui/SET_LOADING", false))
      .catch(() => this.$store.commit("ui/SET_LOADING", false));
  },
  methods: {
    updateAmount(match_id) {
      let item = this.groupAmounts.find(x => x._id == match_id);
      if (!item.enabled) {
        item.quantity = 1;
      } else {
        item.quantity = 0;
      }
      this.$forceUpdate();
    },
    updateQuantity(e) {
      let item = this.groupAmounts.find(x => x._id == e.target.dataset.id);
      item.quantity = e.target.value;
      this.$forceUpdate();
    },
    sendMatchData() {
      let matchData = [];
      for (let i = 0; i < this.groupAmounts.length; i++) {
        let item = this.groupAmounts[i];

        if (item.size) {
          let data = {
            group_user: item._id,
            product_sku: this.productSku,
            size: item.size,
            quantity: item.quantity
          };

          matchData.push(data);
        }
      }

      let payload = {
        matchData: matchData,
        sku: this.productSku
      };

      this.$store.dispatch("groups/sendMatchData", payload).then(result => {
        if (result.status == 200) {
          this.sentMessage = this.$t("match-group-message-send");
        } else {
          this.sentMessage = this.$t("match-group-message-error");
        }
        this.showSentMessage = true;
        setTimeout(() => (this.showSentMessage = false), 4000);
      });
    },
    addProduct() {
      // this.$store.dispatch("application/addCartLog", {
      //   root: true,
      // });
      let groupedItems = [];
      for (let i = 0; i < this.groupSizes.length; i++) {
        let size = this.groupSizes[i];
        let item = groupedItems.find(
          groupedItems => groupedItems.size === size
        );
        if (!item) {
          //create new object and push to array
          let variant = this.productCombinations.find(c => {
            let colorcheck = this.productColor
              ? c.color.toLowerCase() === this.productColor.toLowerCase()
              : true;
            return c.size.toLowerCase() === size.toLowerCase() && colorcheck;
          });
          let amount = 0;
          this.groupAmounts
            .filter(x => x.size == size && x.enabled && x.quantity > 0)
            .forEach(element => {
              amount += parseInt(element.quantity);
            });
          if (amount > 0) {
            groupedItems.push({
              size: size,
              quantity: amount,
              variant: variant.id
            });
          }
        }
      }
      this.$store.dispatch("opener/postMessage", {
        event: "addProduct",
        message: {
          size: groupedItems
        }
      });
      this.$gtag.event("add_to_cart", {
        method: "Google",
        event_callback: function() {
          this.$store.dispatch("application/close");
        }
      });
    },
    logout() {
      this.$store
        .dispatch("auth/logout", this.form)
        .then(() => this.$router.push({ name: "login" }));
    }
  },
  computed: {
    ...mapGetters({
      name: "users/getSelfFirstName",
      group_match: "groups/matchGroup",
      productName: "pageParams/getProductName",
      productSku: "pageParams/getProductSku",
      productCombinations: "pageParams/getProductCombinations",
      productColor: "pageParams/getProductColor",
      desiredQuantity: "pageParams/getDesiredQuantity",
      last_updated_at: "users/getSelfLastUpdated",
      contacts: "contacts/getContacts",
      groups: "groups/getGroups"
    }),
    groupsVerification() {
      return (
        this.groups.some(group => group["has_members"] === true) &&
        this.groups.some(group => group["state"] === "owner")
      );
    },
    friendsVerification() {
      return this.contacts.some(friend => friend["active_bodyprint"] != null);
    }
    // matchStatus() {
    //   if (this.matchResult === "FULL FIT" && !this.productCombinations.find(c => c.size.toLowerCase() === this.matchSize.toLowerCase())) {
    //     return "NO FIT";
    //   }
    //   return this.matchResult;
    // },
  }
};
</script>
<style>
.groupResultCard {
  background-color: #f3f5f8;
  border-color: #f3f5f8;
  height: 200px;
}
.resultText {
  margin-top: 10px;
}
.groupCart {
  background-color: #f3f5f8;
}
#tailie-size .tailie-size-check.show {
  z-index: 9999999;
  right: 5px;
}
.matchResult {
  color: gray;
}
.tailie-add-to-cart {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>
